// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

// 饿了么ui组件库
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/element-variables.scss";
Vue.use(ElementUI);

// 移动端Vant组件库
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

Vue.config.productionTip = false;

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

// 添加千位符
Vue.filter("moneyFormat", function(value) {
  if (!value || value + "" == "" || value == "-") {
    return "";
  }
  return "￥" + (value - 0).toFixed(2);
});

new Vue({
  router,
  components: { App },
  store,
  render: h=>h(App)
}).$mount('#app')

